export enum EditStatus {
  Edit = "edit",
  Confirm = "confirm",
  Succeed = "succeed",
}

export interface ZipAddress {
  pref: string;
  address: string;
  city: string;
  town: string;
  fullAddress: string;
}

export interface ZipAddressResponse {
  code: number;
  data: ZipAddress;
}

export interface BreadcrumbProps {
  text: string;
  disabled: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  to?: Record<string, any>;
  exact?: boolean;
}
